import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroVestidosNovia from './components/HeroVestidosNovia';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import ProcessSection from './components/ProcessSection';
import FAQSection from './components/FAQSection';
import BookingCalendar from './components/BookingCalendar';
import { useSEO } from '../../hooks/useSEO';
import { SchemaMarkup } from '../../components/SEOHead';

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Vestidos de Novia a Medida Barcelona',
  provider: {
    '@type': 'LocalBusiness',
    name: 'Anthony Sánchez Couture',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Rambla de Catalunya, 85, Principal - 2',
      addressLocality: 'Barcelona',
      addressRegion: 'Cataluña',
      postalCode: '08008',
      addressCountry: 'ES',
    },
  },
  areaServed: {
    '@type': 'City',
    name: 'Barcelona',
  },
  description: 'Diseño y confección de vestidos de novia de alta costura a medida en Barcelona. Alta costura artesanal, bordados exclusivos y tejidos de lujo.',
  serviceType: 'Vestidos de Novia Alta Costura',
  priceRange: '€€€€',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '¿Cuánto tiempo antes de la boda debo reservar cita?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Recomendamos reservar con al menos 6-8 meses de antelación para vestidos de alta costura. Para diseños con bordados complejos o tejidos especiales, 10-12 meses es ideal.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Cuál es el precio de un vestido de novia de alta costura?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Nuestros vestidos de novia parten desde 7.200€. El precio final depende del diseño, los tejidos seleccionados, el grado de bordado y los detalles ornamentales.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Puedo traer referencias o ideas de Pinterest?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Por supuesto. Las referencias visuales son una excelente forma de comunicar tu visión. Anthony analizará cada detalle para crear algo único.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Trabajáis con novias internacionales?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sí, trabajamos con novias de toda España, Europa y América Latina. Coordinamos las sesiones de prueba en Barcelona durante visitas planificadas.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Qué pasa si necesito una modificación de última hora?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Incluimos una sesión de ajuste final aproximadamente 2 semanas antes de la boda. También ofrecemos servicio de arreglos urgentes.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Incluye el vestido el velo o accesorios?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'El presupuesto del vestido incluye únicamente la prenda principal. Podemos diseñar a juego un velo, guantes o cinturón bordado como complementos adicionales.',
      },
    },
  ],
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Inicio',
      item: 'https://anthonysanchezc.com',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Vestidos de Novia',
      item: 'https://anthonysanchezc.com/vestidos-novia',
    },
  ],
};

export default function VestidosNovia() {
  useSEO({
    title: 'Vestidos de Novia Barcelona | Alta Costura a Medida | Anthony Sánchez Couture',
    description: 'Vestidos de novia de alta costura a medida en Barcelona. Diseñador moda personalizado en el Eixample. Bordados en oro, tejidos exclusivos y confección artesanal desde 7.200€.',
    keywords: 'vestidos de novia Barcelona, vestidos novia alta costura, diseñador moda personalizado, vestidos novia medida, atelier novia Barcelona, Eixample novia, bordados novia oro',
    canonical: '/vestidos-novia',
    ogTitle: 'Vestidos de Novia Barcelona — Alta Costura a Medida',
    ogDescription: 'Diseñamos vestidos de novia únicos en Barcelona. Alta costura artesanal, tejidos de lujo y bordados exclusivos en el Eixample.',
    ogType: 'website',
  });

  return (
    <div className="min-h-screen bg-white">
      <SchemaMarkup schema={serviceSchema} />
      <SchemaMarkup schema={faqSchema} />
      <SchemaMarkup schema={breadcrumbSchema} />
      <Navbar />
      <main>
        <HeroVestidosNovia />
        <ServicesSection />
        <ProcessSection />
        <TestimonialsSection />
        <FAQSection />
        <BookingCalendar />
      </main>
      <Footer />
    </div>
  );
}